<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>客服管理</el-breadcrumb-item>
        <el-breadcrumb-item>用户查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="供应点：" prop="logisticsSiteId">
              <el-select clearable size="small" v-model="listParams.logisticsSiteId" style="width: 100%" placeholder="请选择供应点">
                <el-option v-for="item in logisticsList" :label="item.logistics" :value="item.logisticsSiteId" :key="item.logistics"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="保障手机号：" prop="contact">
              <el-input clearable size="small" v-model="listParams.contact" placeholder="请输入保障手机号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="审核状态：" prop="status">
              <el-select clearable size="small" v-model="listParams.status" style="width: 100%" placeholder="请选择审核状态">
                <el-option v-for="item in statusList" :label="item.title" :value="item.status" :key="item.title"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData">查询</el-button>

              <el-button size="small" @click="resetForm('listForm')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <el-button class="align-left" type="primary" size="small" @click="toCreate">新增</el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="logisticsSite" align="center" label="供应点"></el-table-column>

        <el-table-column prop="contact" align="center" label="保障手机号"></el-table-column>

        <el-table-column align="center" label="审核状态">
          <template slot-scope="scope">
            <span>{{ scope.row.status === 0 ? "已启用" : "已禁用" }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="toChange(scope.row)">更改</el-button>
            <confirm-button type="text" title="确认切换状态？" @confirmed="enableItem(scope.row)">
              <span>{{ scope.row.status === 0 ? "禁用" : "取消禁用" }}</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <el-form ref="dialogForm" :model="itemParams" label-width="120px">
        <el-form-item label="供应点：" prop="logisticsSiteId" :rules="rulesItem">
          <el-select v-model="itemParams.logisticsSiteId" size="small" placeholder="请选择供应点">
            <el-option v-for="item in logisticsList" :label="item.logistics" :value="item.logisticsSiteId" :key="item.logistics"></el-option>
          </el-select>
        </el-form-item>

        <template v-if="method === 'POST'">
          <el-form-item
            v-for="(contact, index) in itemParams.contacts"
            :label="'保障手机号' + (index + 1) + '：'"
            :key="contact.key"
            :prop="'contacts.' + index + '.mobile'"
            :rules="{
              required: true,
              message: '手机号不能为空',
              trigger: 'blur',
            }"
          >
            <el-input class="el-input--width" v-model="contact.mobile" size="small" clearable placeholder="请输入保障手机号"></el-input>

            <el-button v-if="index === itemParams.contacts.length - 1" type="primary" icon="el-icon-edit" circle size="mini" @click="addContact"></el-button>

            <el-button v-if="index" type="danger" icon="el-icon-delete" circle size="mini" @click="removeContact(contact)"></el-button>
          </el-form-item>
        </template>

        <el-form-item
          v-else
          label="保障手机号："
          prop="contacts[0].mobile"
          :rules="{
            required: true,
            message: '手机号不能为空',
            trigger: 'blur',
          }"
        >
          <el-input clearable size="small" v-model="itemParams.contacts[0].mobile" placeholder="请输入保障手机号"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button :disabled="isDisabled" size="small" type="primary" @click="saveItem('dialogForm')">保 存</el-button>

          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        id: "",
        supplyId: "",
        logisticsSiteId: "",
        contact: "",
        status: "",
      },
      statusList: [
        { status: "", title: "全部" },
        { status: "0", title: "正常" },
        { status: "-1", title: "删除" },
        { status: "1", title: "其他异常" },
      ],
      logisticsTotalList: [],
      logisticsList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      method: "",
      url: "",
      dialogTitle: "",
      dialogVisible: false,
      isDisabled: false,
      itemParams: {
        id: "",
        supplyId: "",
        logisticsSiteId: "",
        contacts: [
          {
            mobile: "",
          },
        ],
      },
      rulesSelect: {
        required: true,
        message: "请选择供应点",
        trigger: "change",
      },
    };
  },
  computed: {
    rulesItem: function () {
      if (this.method === "POST") {
        return this.rulesSelect;
      }
      return null;
    },
  },
  mounted() {
    this.loadLogistics();
    this.loadTableData();
  },
  methods: {
    /**
     * 初始化供应点
     */
    loadLogistics() {
      this.$http({
        url: global.apiUrl + "/users/logisticsSite",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.logisticsTotalList = res.body.data;
            if (this.logisticsTotalList) {
              this.logisticsTotalList.map(item => {
                this.logisticsList.push({
                  logisticsSiteId: item.logisticsId,
                  logistics: item.title,
                });
              });
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      const bodyParams = {
        logisticsSiteId: this.listParams.logisticsSiteId,
        contact: this.listParams.contact,
        status: this.listParams.status,
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      };
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/users/query",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.orderList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 删除条目数据
     * @param row
     */
    enableItem(row) {
      const bodyParams = {
        id: row.id,
        supplyId: row.supplyId,
        status: row.status,
      };
      this.$http({
        url: global.apiUrl + "/users/enable",
        method: "PUT",
        body: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 新增数据对话框
     */
    toCreate() {
      this.dialogVisible = true;
      this.dialogTitle = "新增保障用户";
      this.method = "POST";
      this.url = "/users/adduser";
    },
    /**
     * 更改数据对话框
     * @param row
     */
    toChange(row) {
      this.dialogVisible = true;
      this.dialogTitle = "修改保障用户";
      this.method = "PUT";
      this.url = "/users/updateuser";
      this.itemParams.id = row.id;
      this.itemParams.supplyId = row.supplyId;
      this.itemParams.logisticsSiteId = row.logisticsSiteId;
      this.itemParams.contacts[0].mobile = row.contact;
    },
    /**
     * 删除保障手机号项
     */
    removeContact(item) {
      const index = this.itemParams.contacts.indexOf(item);
      if (index !== -1) {
        this.itemParams.contacts.splice(index, 1);
      }
    },
    /**
     * 新增保障手机号项
     */
    addContact() {
      this.itemParams.contacts.push({
        mobile: "",
        key: Date.now(),
      });
    },
    /**
     * 保存条目数据
     * @param name
     */
    saveItem(name) {
      let bodyParams = {
        supplyId: this.itemParams.supplyId,
        logisticsSiteId: this.itemParams.logisticsSiteId,
      };
      if (this.method === "PUT") {
        bodyParams = Object.assign(bodyParams, {
          id: this.itemParams.id,
          mobile: this.itemParams.contacts[0].mobile,
        });
      } else {
        bodyParams.contacts = this.itemParams.contacts;
        for (const contact of bodyParams.contacts) {
          delete contact.key;
        }
      }
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$http({
            url: global.apiUrl + this.url,
            method: this.method,
            body: bodyParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.isDisabled = false;
                this.dialogVisible = false;
                this.$message.success(res.body.info);
                this.loadTableData();
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.itemParams = {
        id: "",
        supplyId: "",
        logisticsSiteId: "",
        contacts: [
          {
            mobile: "",
          },
        ],
      };
      this.$refs.dialogForm.resetFields();
    },
    /**
     * 重置请求表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
.el-input--width {
  width: 75%;
}
</style>
